.logo {
    display: inline-flex;
    align-items: center;
    gap: var(--space-xs);
    color: var(--color-text-primary);
}

.mark {
    flex: none;
    inline-size: 2rem;
    block-size: 2rem;
}

.plate {
    fill: var(--color-brand);
}

/*
 * Colour only. The stroke widths and the roof's opacity are attributes on the
 * element, read from `logoMark.json` — a CSS declaration here would win over
 * the attribute and put the geometry back in two places, which is the drift
 * that file exists to stop.
 */
.roof {
    stroke: var(--color-text-on-brand);
}

.bar {
    stroke: var(--color-text-on-brand);
}

/*
 * `line-height: 1` on a lowercase display face leaves the visual centre of the
 * word above the box's centre, because there are no ascenders to fill the top —
 * "thuiscoach" has a t and an h, but the mass sits on the x-height. A single
 * pixel of optical correction lines it up with the middle of the mark.
 */
.wordmark {
    font-family: var(--font-display);
    font-variation-settings: 'wdth' var(--display-width-tight);
    font-size: var(--text-xl);
    font-weight: var(--weight-black);
    letter-spacing: var(--tracking-tight);
    line-height: 1;
    text-transform: lowercase;
    translate: 0 1px;
}

.wordmarkAccent {
    color: var(--color-brand-text);
}

/*
 * `sm` is the header size, and it was too small to hold its own beside the nav.
 * Grown from 1.75rem to 2rem with the wordmark a step up to match — the owner
 * asked for *"iets groter zodat het mooier centraal staat"*.
 */
.sm .mark {
    inline-size: 2rem;
    block-size: 2rem;
}

.sm .wordmark {
    font-size: var(--text-lg);
}

.lg .mark {
    inline-size: 2.75rem;
    block-size: 2.75rem;
}

.lg .wordmark {
    font-size: var(--text-2xl);
}

/*
 * Variant for surfaces that stay dark regardless of the active theme.
 */
.onDark {
    color: #ffffff;
}

.onDark .plate {
    fill: rgb(255 255 255 / 0.14);
}

.onDark .roof,
.onDark .bar {
    stroke: #ffffff;
}

.onDark .wordmarkAccent {
    color: var(--tc-teal-200);
}
